import React, { useState } from 'react'
import PropTypes from 'prop-types'

import ValidatedInput from '../ValidatedInput'
import { minLengthValidator } from '../../../helpers/validationRules'

import {
  NoMarkSuccessComponent,
  NoMarkErrorComponent
} from '../DefaultTooltipComponents'

const ValidatedPromoInput = React.forwardRef(
  ({ message, onChange, ...restProps }, ref) => {
    const handleChange = (event) => {
      setValue(event.target.value)
      onChange && onChange(event)
    }
    const [value, setValue] = useState('')
    const rules = [
      {
        match: minLengthValidator(1),
        successMessage: message,
        errorMessage: message
      }
    ]
    return (
      <ValidatedInput
        ErrorComponent={NoMarkErrorComponent}
        SuccessComponent={NoMarkSuccessComponent}
        rules={value.length < 1 ? rules : []}
        ref={ref}
        {...restProps}
        value={value}
        onChange={handleChange}
      />
    )
  }
)

ValidatedPromoInput.propTypes = {
  message: PropTypes.string
}

export default ValidatedPromoInput
